import React from "react";
import { Form, Input } from "antd";
import { useTranslation } from "react-i18next";

const AdminEmail: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Form.Item
      name="email"
      label="Email"
      // rules={[
      //   {
      //     type: "email",
      //     required: true,
      //     message: t("error:email_is_required"),
      //   },
      // ]}
    >
      <Input />
    </Form.Item>
  );
};

export default AdminEmail;
